"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHelp = exports.useTableSearch = void 0;
const user_settings_context_1 = require("../../../settings/user/user-settings-context");
const react_1 = __importStar(require("react"));
const lib_1 = require("use-debounce/lib");
const update_effect_1 = require("../../../utils/update-effect");
function useTableSearch({ tableId, version, }) {
    const searchbarRef = (0, react_1.useRef)(null);
    const { getTableSettings, setTableSettings } = (0, react_1.useContext)(user_settings_context_1.UserSettingsContext);
    let settings;
    let initQuery = '';
    if (tableId !== '') {
        settings = getTableSettings(tableId, version);
        if ((settings === null || settings === void 0 ? void 0 : settings.searchQuery) !== undefined) {
            initQuery = settings === null || settings === void 0 ? void 0 : settings.searchQuery;
        }
    }
    const [searchQuery, directSetSearchQuery] = (0, react_1.useState)(initQuery);
    /**
     * Debounces set search query.
     */
    const [setSearchQuery] = (0, lib_1.useDebouncedCallback)(directSetSearchQuery, 500);
    /**
     * Updates user settings.
     */
    (0, update_effect_1.useUpdateEffect)(() => {
        const newSettings = {
            ...(settings !== null && settings !== void 0 ? settings : {}),
            searchQuery,
            version,
        };
        setTableSettings(tableId, newSettings);
    }, [searchQuery]);
    return { searchbarRef, searchQuery, setSearchQuery, directSetSearchQuery };
}
exports.useTableSearch = useTableSearch;
function useHelp() {
    const searchHighlightHelp = (react_1.default.createElement("table", null,
        react_1.default.createElement("tbody", null,
            react_1.default.createElement("tr", null,
                react_1.default.createElement("td", null,
                    "Pro formulaci dotazu jsou k dispozici n\u00E1sleduj\u00EDc\u00ED",
                    ' ',
                    react_1.default.createElement("i", null,
                        react_1.default.createElement("u", null,
                            react_1.default.createElement("b", null,
                                "parametry a oper\u00E1tory",
                                react_1.default.createElement("a", null)))),
                    ":",
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("table", { cellPadding: "3", cellSpacing: "0" },
                        react_1.default.createElement("tbody", null,
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("th", null, "Oper\u00E1tor, parametr"),
                                react_1.default.createElement("th", null, "Funkce"),
                                react_1.default.createElement("th", null, "P\u0159\u00EDklad")),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null, "slovo"),
                                react_1.default.createElement("td", null, "Vyhled\u00E1 dokument, v n\u011Bm\u017E se zadan\u00E9 slovo vyskytuje ve v\u0161ech jeho gramatick\u00FDch tvarech, velk\u00E1 a mal\u00E1 p\u00EDsmena nejsou z\u00E1vazn\u00E1. Tato funkce je automatick\u00E1 u v\u0161ech slov v kombinaci s jin\u00FDmi oper\u00E1tory."),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("i", null, "vazba"))),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null, "fr\u00E1ze: \" \""),
                                react_1.default.createElement("td", null, "Vyhled\u00E1 dokument, v n\u011Bm\u017E se zadan\u00E1 fr\u00E1ze vyskytuje p\u0159esn\u011B v tom tvaru a po\u0159ad\u00ED slov, jak byla zad\u00E1na. Flexe je vypnuta. Takto lze vyhledat i slova, kter\u00E1 nejsou ve slovn\u00EDku (lematiz\u00E1toru), v\u010Detn\u011B \u0159et\u011Bzc\u016F, kter\u00E9 nejsou slovy."),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("i", null,
                                        "\"soudcem zpravodajem Nov\u00E1kem\"",
                                        react_1.default.createElement("br", null),
                                        "\"87/1991\"",
                                        react_1.default.createElement("br", null),
                                        "\"I. \u00DAS 254/97\""))),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null,
                                    "slovo AND slovo alt.",
                                    react_1.default.createElement("br", null),
                                    " slovo slovo"),
                                react_1.default.createElement("td", null, "Vyhled\u00E1 dokument, v n\u011Bm\u017E se vyskytuj\u00ED ob\u011B slova. Tato funkce je p\u0159ednastaven\u00E1. Oper\u00E1tor AND lze vynechat."),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("i", null,
                                        "vazba mladistv\u00FD ",
                                        react_1.default.createElement("br", null),
                                        " vazba AND mladistv\u00FD"))),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null, "slovo OR slovo"),
                                react_1.default.createElement("td", null, "Vyhled\u00E1 dokument, v n\u011Bm\u017E se vyskytuje jedno nebo druh\u00E9 slovo nebo ob\u011B slova."),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("i", null, "vazba OR mladistv\u00FD"))),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null, "NOT slovo"),
                                react_1.default.createElement("td", null, "Vyhled\u00E1 dokument, v n\u011Bm\u017E se zadan\u00E9 slovo nevyskytuje."),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("i", null, "NOT vyho\u0161\u0165ovac\u00ED"))),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null, "slovo SENTENCE slovo"),
                                react_1.default.createElement("td", null, "Vyhled\u00E1 dokument, v n\u011Bm\u017E se zadan\u00E1 slova vyskytuj\u00ED v jedn\u00E9 v\u011Bt\u011B bez ohledu na po\u0159ad\u00ED. Upozorn\u011Bn\u00ED: v\u011Btou je pro NALUS sekvence znak\u016F kon\u010D\u00EDc\u00ED te\u010Dkou, bez ohledu na to, jde-li s\u00E9manticky skute\u010Dn\u011B o konec v\u011Bty."),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("i", null, "vazba SENTENCE mladistv\u00FD"))),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null, "slovo PARAGRAPH slovo"),
                                react_1.default.createElement("td", null, "Vyhled\u00E1 dokument, v n\u011Bm\u017E se zadan\u00E1 slova vyskytuj\u00ED v jednom odstavci bez ohledu na po\u0159ad\u00ED."),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("i", null, "vazba PARAGRAPH n\u00E1hrada"))),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null, "slovo NEAR(po\u010Det slov) slovo"),
                                react_1.default.createElement("td", null, "Vyhled\u00E1 dokument, v n\u011Bm\u017E se zadan\u00E1 slova vyskytuj\u00ED ve vzd\u00E1lenosti do zadan\u00E9ho po\u010Dtu slov bez ohledu na po\u0159ad\u00ED."),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("i", null, "vazba NEAR(10) cizinec"))),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null, "* divok\u00E1 karta"),
                                react_1.default.createElement("td", null, "Vyhled\u00E1 dokument, v n\u011Bm\u017E se vyskytuje slovo se zadan\u00FDm \u0159et\u011Bzcem znak\u016F; na m\u00EDst\u011B * mohou b\u00FDt libovoln\u00E9 znaky (vp\u0159edu \u010Di vzadu)."),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("i", null,
                                        "Ducho* ",
                                        react_1.default.createElement("br", null),
                                        " *moravsk\u00FD"))))))))));
    const searchFilterBoxHelp = (react_1.default.createElement("ul", null,
        react_1.default.createElement("li", null,
            react_1.default.createElement("b", null, "Podporovan\u00E9 operace"),
            ":",
            react_1.default.createElement("br", null),
            react_1.default.createElement("b", null, "=="),
            " p\u0159esn\u00E1 zhoda",
            react_1.default.createElement("br", null),
            react_1.default.createElement("b", null, "?="),
            " pod\u0159et\u011Bzec",
            react_1.default.createElement("br", null),
            react_1.default.createElement("b", null, "AND"),
            " podm\u00EDnka \"a z\u00E1rove\u0148\"",
            react_1.default.createElement("br", null),
            react_1.default.createElement("b", null, "OR"),
            " podm\u00EDnka \"nebo\"",
            react_1.default.createElement("br", null),
            react_1.default.createElement("b", null, "()"),
            " z\u00E1vorky")));
    return {
        searchFilterBoxHelp,
        searchHighlightHelp,
    };
}
exports.useHelp = useHelp;
//# sourceMappingURL=table-search-hook.js.map